import { Injectable, signal, Signal } from "@angular/core";
import GeobusNavigationExtension from "./geobus-navigation.extension";
import { IType } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })
export default class GeobusTopicExtension extends GeobusNavigationExtension {

    public get component(): IType<unknown> | null {
        return null;
    }

    public get identifier(): string | null {
        return "GeobusTopicExtensionName";
    }

    public get title(): Signal<string> {
        return signal("SIDE_MENU.DATA.TOPICS").asReadonly();
    }

    public get category(): string {
        return "data";
    }

    public get state(): { name: string } {
        return { name: "app.topics" };
    }

    public get icon(): string {
        return "list";
    }

}
